import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { LocalStorage } from '@/app/core/local-storage';

@Injectable({ providedIn: 'root' })
export class UtmService {
  private router = inject(Router);
  private localStorage = inject(LocalStorage);
  private isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  init(): void {
    if (!this.isBrowser) {
      return;
    }

    this.captureFromUrl(this.router.url);

    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => this.captureFromUrl(event.urlAfterRedirects));
  }

  private captureFromUrl(url: string): void {
    const params = new URLSearchParams(url.split('?')[1] ?? '');

    const source = params.get('utm_source');
    const medium = params.get('utm_medium');
    const campaign = params.get('utm_campaign');

    if (source) {
      this.localStorage.setItem('utmSource', source);
    }
    if (medium) {
      this.localStorage.setItem('utmMedium', medium);
    }
    if (campaign) {
      this.localStorage.setItem('utmCampaign', campaign);
    }
  }
}
